var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-navigation-drawer',{class:{
        'navigation-drawer': true,
        'elevation-2': hover,
      },attrs:{"app":"","value":(!_vm.isMobile) ? hover : _vm.drawer,"permanent":!_vm.isMobile,"expand-on-hover":!_vm.isMobile,"width":320},on:{"input":_vm.onToggleDrawer}},[_c('div',{staticClass:"navigation-drawer__container"},[_c('navigation-items',{attrs:{"items":_vm.navItems,"hover":hover}})],1)])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }